module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/thumbnail_Enne Taniguchi-db8861f3cbfe6306e32c37f40dd4805e.png";